import { HistoryGraphContainer } from 'pages/NewOverview/styles';
import styled from 'styled-components';
import { CardsContainerLoading, CardsGraphContainer } from '../styles';

export const TrendsCardContainer = styled(HistoryGraphContainer)<{ expandedSplit: boolean }>`
  width: ${({ expandedSplit }) => (expandedSplit ? '50%' : '500px')};
  height: 364px;
  display: flex;
  gap: 20px;
  position: relative;

  @media (max-width: 768px) {
    height: 435px;
    width: 100%;
  }
`;

export const TrendsCardsGraphContainer = styled(CardsGraphContainer)`
  @media (max-width: 768px) {
    margin: 0 -8px;
  }
`;

export const TrendsCardsCardLoading = styled(CardsContainerLoading)<{ expandedSplit: boolean }>`
  width: ${({ expandedSplit }) => (expandedSplit ? '50%' : '500px')};
  .skeleton-span, .skeleton-container-span {
    width: ${({ expandedSplit }) => (expandedSplit ? '100%' : '500px')};
  }

  @media (max-width: 768px) {
    width: 100%;

    .skeleton-span, .skeleton-container-span {
      width: 100%;
    }
  }
`;
